import React, { Component } from 'react';
import { HashRouter as Router, Route } from 'react-router-dom';
import Login from './common/Login.js';
import Home from './common/Home.js';
import Dashboard from './common/Dashboard.js';
import CountryList from './components/LocationMaster/CountryMaster/CountryList.js';
import GovernorateList from './components/LocationMaster/GovernorateMaster/GovernorateList.js';
import GovernorateAddTab from './components/LocationMaster/GovernorateMaster/GovernorateAddTab.js';
import AreaList from './components/LocationMaster/AreaMaster/AreaList.js';
import AreaAddTab from './components/LocationMaster/AreaMaster/AreaAddTab.js';
import TermsAddTab from './components/Terms/TermsAddTab.js';
import AboutUsAddTab from './components/AboutUs/AboutUsAddTab.js';
// import ContactUsList from './components/ContactUs/ContactUsList.js';
// import ProductAddTab from './components/ServiceProviderMaster/ProductAdd';
// import GarageList from './ServiceProviders/Garage/GarageList';
// import AddBusinessCategoryMaste from './components/CountryMaster/AddBusinessCategoryMaster.js';
// import AddBusinessCategoryMaster from './components/CountryMaster/AddBusinessCategoryMaster.js';
// import AddCountyCode from './components/CountryMaster/AddCountryCode.js';
// import ServiceTypeMaster from './components/CountryMaster/ServiceTypeMaster.js';
import CountryAddTab from './components/LocationMaster/CountryMaster/CountryAddTab.js';
import SellerList from './components/UserMaster/Sellers/SellersList.js';
import SellerAddTab from './components/UserMaster/Sellers/SellersAddTab.js';
import DriverList from './components/UserMaster/Driver/DriverList.js';
import DriverAddTab from './components/UserMaster/Driver/DriverAddTab.js';
import UserList from './components/UserMaster/User/UsersList.js';
import ProfileView from './components/UserMaster/User/ProfileView.jsx';
import CarSaleView from './components/ServiceProviderMaster/CarSaleView.jsx';
import PaymentDetail from './components/PaymentMaster/PaymentDetail.jsx';
import AssignPlan from './components/ServiceProviderMaster/AssignPlan.jsx';
import UserAddTab from './components/UserMaster/User/UsersAddTab.js';
import PaymentList from './components/PaymentMaster/PaymentList.js';
import PaymentAddTab from './components/PaymentMaster/PaymentAddTab';
import BusinessList from './components/BusinessTypeMaster/BusinessList.js';
import BusinessAddTab from './components/BusinessTypeMaster/BusinessAddTab.js';
import CouponList from './components/CouponMaster/CouponList.js';
import CouponAddTab from './components/CouponMaster/CouponAddTab.js';
import RoleList from './components/RoleMaster/RoleList.js';
import RoleAddTab from './components/RoleMaster/RoleAddTab.js';
import CategoryList from './components/CategoryMaster/CategoryList.js';
import CategoryAddTab from './components/CategoryMaster/CategoryAddTab.js';
import SellTypeList from './components/SellTypeMaster/SellTypeList.js';
import SellTypeAddTab from './components/SellTypeMaster/SelltypeAddTab.js';
import LanguageList from './components/LanguageMaster/LanguageList.js';
import LanguageAdd from './components/LanguageMaster/LanguageAdd.js';
import DeliveryChargesAddTab from './components/DeliveryCharge/DeliveryChargesAddTab.js';
import DeliveryList from './components/DeliveryCharge/DeliveryList.js';
import DeliveryTimeList from './components/DeliveryTime/DeliveryTimeList.js';
import DeliveryTimeAddTab from './components/DeliveryTime/DeliveryTimeAddTab.js';
import OrderStatusList from './components/OrderStatusMaster/OrderStatusList.js';
import OrderStatusAddTab from './components/OrderStatusMaster/OrderStatusAddTab.js';
import VarientsList from './components/VarientsMaster/VarientsList.js';
import VarientsAddTab from './components/VarientsMaster/VarientsAddTab.js';
import OrderList from './components/OrderMaster/OrderList.js';
import ProductList from './components/ServiceProviderMaster/ProductList.js';
import CountryMaster from './components/CountryMaster/CountryMaster.js';
import BusinessCategoryMaster from './components/CountryMaster/BusinessCategoryMaster.js';
import VehicleType from './components/CountryMaster/VehicleType.js';
import SparePartMaster from './components/CountryMaster/SparePartMaster.js';
import ManageCatagory from './ServiceProviders/CarsAgent/ManageCatagory.js';
import ManageCars from './ServiceProviders/CarsAgent/ManageCars.js';
import ManageShowRoom from './ServiceProviders/CarsAgent/ManageShowRoom.js';
import ManageWorkShop from './ServiceProviders/CarsAgent/ManageWorkShop.js';
import AddNewCategory from './ServiceProviders/CarsAgent/AddNewCategory.js';
import AddNewManageCars from './ServiceProviders/CarsAgent/AddNewManageCars.js';
import AddNewManageShowRoom from './ServiceProviders/CarsAgent/AddNewManageShowRoom.js';
import AddNewManageWorkShop from './ServiceProviders/CarsAgent/AddNewManageWorkShop.js';
import AddServiceTypeMaster from './components/CountryMaster/AddServiceTypeMaster.js';
import AddCarBrandMaster from './components/CountryMaster/AddCarBrandMaster.js';
import AddVehicleType from './components/CountryMaster/AddVehicleType.js';
import AddCarArea from './components/CountryMaster/AddCarArea.js';
import AddCarName from './components/CountryMaster/AddCarName.js';
import AddSparePart from './components/CountryMaster/AddSparePart.js';
import AddSparePartType from './components/CountryMaster/AddSparePartType.js';
import AddCountryCode from './components/CountryMaster/AddCountryCode.js';
import AddCountry from './components/CountryMaster/AddCountry.js';
import Registeration from './common/Registeration.js';
import DeleteBusinessData from './deleteBusinessData/deleteBusinessData';
import AddGrageCategory from './components/CategoryMaster/AddGrageCategory';
import AddSparePartCategory from './components/CategoryMaster/AddSparePartCategory.js';
import AddCardealerCategory from './components/CategoryMaster/AddCardealerCategory.js';
import ProductListTable from './components/ProductMaster/ProductList.js';
import AddProduct from './components/ProductMaster/AddProduct';
import AddairConditioningCategory from './components/CategoryMaster/AddairConditioningCategory.js';
import AddcarInsuranceCategory from './components/CategoryMaster/AddcarInsuranceCategory.js';
import AddcarProtectionCategory from './components/CategoryMaster/AddcarProtectionCategory.js';
import AddCarWashCategory from './components/CategoryMaster/AddCarWashCategory.js';
import AdddrivingSchoolCategory from './components/CategoryMaster/AdddrivingSchoolCategory.js';
import CarService from './components/ServiceTypeMaster/CarService.js';
import quickService from './components/ServiceTypeMaster/quickService.js';
import AddCarService from './components/ServiceTypeMaster/AddCarService.js';
import AddQuickService from './components/ServiceTypeMaster/AddQuickService.js';
import Package from './components/NewComp/Packages/Package.jsx';
import GarageUpdate from './components/ServiceProviderMaster/GarageUpdate.jsx';
import SparePartsUpdate from './components/ServiceProviderMaster/SparePartsUpdate.jsx';
import CarModel from './components/CarDetail/CarModel/CarModel.jsx';
import Cylinder from './components/CarDetail/Cylinder/Cylinder.jsx';
import ModelYear from './components/CarDetail/ModelYear/ModelYear.jsx';
import ModelYearAdd from './components/CarDetail/ModelYear/ModelYearAdd.jsx';
import FuelType from './components/CarDetail/FuelType/FuelType.jsx';
import Doors from './components/CarDetail/Doors/Doors.jsx';
import Seats from './components/CarDetail/Seats/Seats.jsx';
import Color from './components/CarDetail/Color/Color.jsx';
import Safety from './components/CarDetail/Safety/Safety.jsx';
import Comfort from './components/CarDetail/Comfort/Comfort.jsx';
import CarModelAdd from './components/CarDetail/CarModel/CarModelAdd.jsx';
import CylinderAdd from './components/CarDetail/Cylinder/CylinderAdd.jsx';
import FuelTypeAdd from './components/CarDetail/FuelType/FuelTypeAdd.jsx';
import DoorsAdd from './components/CarDetail/Doors/DoorsAdd.jsx';
import ColorAdd from './components/CarDetail/Color/ColorAdd.jsx';
import SafetyAdd from './components/CarDetail/Safety/SafetyAdd.jsx';
import ComfortAdd from './components/CarDetail/Comfort/ComfortAdd.jsx';
import SeatsAdd from './components/CarDetail/Seats/SeatsAdd.jsx';
import SpareProducts from './components/SparePartMaster/SpareProducts.jsx';
import ServiceProvider from './components/UserMaster/User/ServiceProvider.jsx';
import TermsAdd from './components/Terms/TermsAdd.js';
import CarDealersUpdate from './components/ServiceProviderMaster/CarDealersUpdate.jsx';
import Notification from './components/Notification/Notification.jsx';
import CarForSaleUpdate from './components/ServiceProviderMaster/CarForSaleUpdate.jsx';
import CarModelNew from './components/CarDetail/CarModelNew/CarModelNew.jsx';
import CarModelForm from './components/CarDetail/CarModelNew/CarModelForm.jsx';
import ContactUS from './components/ContactUs/ContactUS.js';
import CarMB from './components/CarDetail/CarModel/CarMB.js';
import AddEditArea from './components/LocationMaster/AreaMaster/AddEditArea.js';
import CarRentUpdate from './components/ServiceProviderMaster/CarRentUpdate.jsx';
import TaxiOwnersUpdate from './components/ServiceProviderMaster/TaxiOwnersUpdate.jsx';
import CarWashUpdate from './components/ServiceProviderMaster/CarWashUpdate.jsx';
import CarInsuranceUpdate from './components/ServiceProviderMaster/CarInsuranceUpdate.jsx';
import DrivingSchoolUpdate from './components/ServiceProviderMaster/DrivingSchoolUpdate.jsx';
import CarProtectionUpdate from './components/ServiceProviderMaster/CarProtectionUpdate.jsx';
import CarConditioningUpdate from './components/ServiceProviderMaster/CarConditioningUpdate.jsx';
import QuickServiceUpdate from './components/ServiceProviderMaster/QuickServiceUpdate.jsx';
import TowingOwnerUpdate from './components/ServiceProviderMaster/TowingOwnerUpdate.jsx';
// import { ContryMasterAddCountry } from './components/CountryMaster/ContryMasterAddContry';

class Routes extends Component {
  render() {
    return (
      <Router baseName="/index.html">
        {localStorage.getItem('loged_In') !== 'true' ? (
          <Route exact path={'/'} component={Login} />
        ) : (
          <Home>
            <Route exact path={'/Registeration'} component={Registeration} />
            <Route exact path={'/'} component={Dashboard} />
            <Route exact path={'/user'} component={UserList} />
            <Route
              exact
              path={'/service-provider'}
              component={ServiceProvider}
            />
            <Route exact path={'/user/add/:user_id'} component={UserAddTab} />
            <Route exact path={'/user/view/:userId'} component={ProfileView} />
            <Route
              exact
              path={'/cars-for-sale/view/:carSaleId'}
              component={CarSaleView}
            />
            <Route
              exact
              path={'/payment/view/:subscriptionId'}
              component={PaymentDetail}
            />
            <Route
              exact
              path={'/assign-plan/:type/:businessId'}
              component={AssignPlan}
            />
            <Route
              exact
              path={'/service-provider/view/:userId/:businessId'}
              component={ProfileView}
            />
            <Route exact path={'/category'} component={CategoryList} />
            <Route
              exact
              path={'/category/add/:category_id?'}
              component={CategoryAddTab}
            />
            <Route
              exact
              path={'/delivery-charge/add/:charges_id?'}
              component={DeliveryChargesAddTab}
            />
            <Route exact path={'/delivery-charge'} component={DeliveryList} />
            <Route exact path={'/orders/:type?'} component={OrderList} />
            {/* <Route
							exact
							path={'/ServiceProviders/:type?'}
							component={ProductList}
						/> */}
            <Route exact path={'/CarDetail/CarModel'} component={CarModelNew} />
            <Route
              exact
              path={'/CarDetail/CarModel/:carModelAdd'}
              component={CarModelForm}
            />
            <Route exact path={'/CarDetail/CarBrand'} component={CarModel} />
            <Route
              exact
              path={'/CarDetail/CarBrand/Add'}
              component={CarModelAdd}
            />
            <Route
              exact
              path={'/CarDetail/CarBrand/Update/:cmUUID'}
              component={CarModelAdd}
            />
            <Route exact path={'/CarDetail/Cylinder'} component={Cylinder} />
            <Route
              exact
              path={'/CarDetail/Cylinder/Add'}
              component={CylinderAdd}
            />
            <Route
              exact
              path={'/CarDetail/Cylinder/Update/:cylUUID'}
              component={CylinderAdd}
            />
            <Route exact path={'/CarDetail/ModelYear'} component={ModelYear} />
            <Route
              exact
              path={'/CarDetail/ModelYear/Add'}
              component={ModelYearAdd}
            />
            <Route
              exact
              path={'/CarDetail/ModelYear/Update/:myUUID'}
              component={ModelYearAdd}
            />
            <Route exact path={'/CarDetail/FuelType'} component={FuelType} />
            <Route
              exact
              path={'/CarDetail/FuelType/Add'}
              component={FuelTypeAdd}
            />
            <Route
              exact
              path={'/CarDetail/FuelType/Update/:ftUUID'}
              component={FuelTypeAdd}
            />
            <Route exact path={'/CarDetail/Doors'} component={Doors} />
            <Route exact path={'/CarDetail/Doors/Add'} component={DoorsAdd} />
            <Route
              exact
              path={'/CarDetail/Doors/Update/:drUUID'}
              component={DoorsAdd}
            />
            <Route exact path={'/CarDetail/Seats'} component={Seats} />
            <Route exact path={'/CarDetail/Seats/Add'} component={SeatsAdd} />
            <Route
              exact
              path={'/CarDetail/Seats/Update/:stUUID'}
              component={SeatsAdd}
            />
            <Route exact path={'/CarDetail/Color'} component={Color} />
            <Route exact path={'/CarDetail/Color/Add'} component={ColorAdd} />
            <Route
              exact
              path={'/CarDetail/Color/Update/:clUUID'}
              component={ColorAdd}
            />
            <Route exact path={'/CarDetail/Safety'} component={Safety} />
            <Route exact path={'/CarDetail/Safety/Add'} component={SafetyAdd} />
            <Route
              exact
              path={'/CarDetail/Safety/Update/:sfUUID'}
              component={SafetyAdd}
            />
            <Route exact path={'/CarDetail/Comfort'} component={Comfort} />
            <Route
              exact
              path={'/CarDetail/Comfort/Add'}
              component={ComfortAdd}
            />
            <Route
              exact
              path={'/CarDetail/Comfort/Update/:cfUUID'}
              component={ComfortAdd}
            />
            <Route
              exact
              path={'/ServiceProviders/:type?'}
              component={ProductList}
            />
            <Route
              exact
              path={'/ServiceProviders/Garage/Update/:grUpdate'}
              component={GarageUpdate}
            />
            <Route
              exact
              path={'/ServiceProviders/Spare-Parts/Update/:spUpdate'}
              component={SparePartsUpdate}
            />
            <Route
              exact
              path={'/ServiceProviders/Car-Dealers/Update/:cdUpdate'}
              component={CarDealersUpdate}
            />
            <Route
              exact
              path={'/ServiceProviders/Car-Rent/Update/:cRUpdate'}
              component={CarRentUpdate}
            />
            <Route
              exact
              path={'/ServiceProviders/Taxi/Update/:tOUpdate'}
              component={TaxiOwnersUpdate}
            />
            <Route
              exact
              path={'/ServiceProviders/Car-Towing/Update/:tWUpdate'}
              component={TowingOwnerUpdate}
            />
            <Route
              exact
              path={'/ServiceProviders/Car-Wash/Update/:cWUpdate'}
              component={CarWashUpdate}
            />
            <Route
              exact
              path={'/ServiceProviders/Car-Insurance/Update/:cIUpdate'}
              component={CarInsuranceUpdate}
            />
            <Route
              exact
              path={'/ServiceProviders/Car-Protection/Update/:cPUpdate'}
              component={CarProtectionUpdate}
            />
            <Route
              exact
              path={'/ServiceProviders/Car-Conditioning/Update/:cCUpdate'}
              component={CarConditioningUpdate}
            />
            <Route
              exact
              path={'/ServiceProviders/Driving-School/Update/:dSUpdate'}
              component={DrivingSchoolUpdate}
            />
            <Route
              exact
              path={'/ServiceProviders/Quick-Service/Update/:qSUpdate'}
              component={QuickServiceUpdate}
            />
            {/* <Route
							exact
							path={'/ServiceProviders/CarForSale/Update/:cfsUpdate'}
							component={CarForSaleUpdate}
						/> */}
            {/* <Route
							exact
							path={'/ServiceProviders/:type?'}
							component={GarageList}
						/> */}
            {/* <Route
							exact
							path={'/ServiceProviders/:type/:add?'}
							component={ProductAddTab}
						/> */}
            {/* <Route exact path={"/orders/auction"} component={OrderList} /> */}
            <Route exact path={'/seller'} component={SellerList} />
            <Route
              exact
              path={'/seller/add/:seller_id?'}
              component={SellerAddTab}
            />
            <Route exact path={'/varients'} component={VarientsList} />
            <Route
              exact
              path={'/varients/add/:varients_id?'}
              component={VarientsAddTab}
            />
            <Route exact path={'/delivery-time'} component={DeliveryTimeList} />
            <Route
              exact
              path={'/delivery-time/add/:deliveryTime_id?'}
              component={DeliveryTimeAddTab}
            />
            <Route exact path={'/order-status'} component={OrderStatusList} />
            <Route
              exact
              path={'/order-status/add/:orderstatus_id?'}
              component={OrderStatusAddTab}
            />
            <Route exact path={'/language'} component={LanguageList} />
            <Route
              exact
              path={'/language/add/:language_id?'}
              component={LanguageAdd}
            />
            <Route exact path={'/sell-type'} component={SellTypeList} />
            <Route
              exact
              path={'/sell-type/add/:seller_id?'}
              component={SellTypeAddTab}
            />
            <Route exact path={'/business-type'} component={BusinessList} />
            <Route
              exact
              path={'/business-type/add/:seller_id?'}
              component={BusinessAddTab}
            />
            <Route exact path={'/payment'} component={PaymentList} />
            <Route
              exact
              path={'/payment/add/:payment_id?'}
              component={PaymentAddTab}
            />
            <Route exact path={'/coupon'} component={CouponList} />
            <Route
              exact
              path={'/coupon/add/:coupon_id?'}
              component={CouponAddTab}
            />
            <Route
              exact
              path={'/CountryMaster/:type?'}
              component={CountryMaster}
            />
            <Route
              exact
              path={'/CountryMaster/:type?/add/Country'}
              component={AddCountry}
            />
            <Route
              exact
              path={'/CountryMaster/:type?/add/CountryCode'}
              component={AddCountryCode}
            />
            <Route exact path={'/role'} component={RoleList} />
            <Route exact path={'/role/add/:role_id?'} component={RoleAddTab} />
            <Route exact path={'/driver'} component={DriverList} />{' '}
            <Route
              exact
              path={'/driver/add/:driver_id?'}
              component={DriverAddTab}
            />
            <Route exact path={'/country'} component={CountryList} />
            <Route
              exact
              path={'/country/add/:country_id?'}
              component={CountryAddTab}
            />
            <Route exact path={'/governorate'} component={GovernorateList} />
            <Route
              exact
              path={'/governorate/add/:governorate_id?'}
              component={GovernorateAddTab}
            />
            <Route exact path={'/area'} component={AreaList} />
            <Route exact path={'/area/add/:area_id?'} component={AddEditArea} />
            <Route exact path={'/terms'} component={TermsAdd} />
            <Route exact path={'/terms/add'} component={TermsAddTab} />
            <Route exact path={'/about'} component={AboutUsAddTab} />
            <Route
              exact
              path={'/BusinessCategoryMaster/:type?'}
              component={BusinessCategoryMaster}
            />
            <Route
              exact
              path={'/BusinessCategoryMaster/Add/GarageCategory'}
              component={AddGrageCategory}
            />
            <Route
              exact
              path={'/BusinessCategoryMaster/Update/GarageCategory/:garageUUID'}
              component={AddGrageCategory}
            />
            <Route
              exact
              path={'/BusinessCategoryMaster/SparePartUpdate/:spareUUID'}
              component={AddSparePartCategory}
            />
            <Route
              exact
              path={'/BusinessCategoryMaster/Add/CarConditioningCategory'}
              component={AddairConditioningCategory}
            />
            <Route
              exact
              path={
                '/BusinessCategoryMaster/Update/CarConditioningCategory/:airconditionUUID'
              }
              component={AddairConditioningCategory}
            />
            <Route
              exact
              path={'/BusinessCategoryMaster/Add/CarInsuranceCategory'}
              component={AddcarInsuranceCategory}
            />
            <Route
              exact
              path={
                '/BusinessCategoryMaster/Update/CarInsuranceCategory/:carinsuranceUUID'
              }
              component={AddcarInsuranceCategory}
            />
            <Route
              exact
              path={'/BusinessCategoryMaster/Add/CarProtectionCategory'}
              component={AddcarProtectionCategory}
            />
            <Route
              exact
              path={
                '/BusinessCategoryMaster/Update/CarProtectionCategory/:carprotectionUUID'
              }
              component={AddcarProtectionCategory}
            />
            <Route
              exact
              path={'/BusinessCategoryMaster/Add/CarWashCategory'}
              component={AddCarWashCategory}
            />
            <Route
              exact
              path={
                '/BusinessCategoryMaster/Update/CarWashCategory/:carwashUUID'
              }
              component={AddCarWashCategory}
            />
            <Route
              exact
              path={'/BusinessCategoryMaster/Add/SparePartsCategory'}
              component={AddSparePartCategory}
            />
            <Route
              exact
              path={'/BusinessCategoryMaster/Add/CarDealersCategory'}
              component={AddCardealerCategory}
            />
            <Route
              exact
              path={
                '/BusinessCategoryMaster/Update/SparePartsCategory/:spareUUID'
              }
              component={AddSparePartCategory}
            />
            <Route
              exact
              path={'/BusinessCategoryMaster/Add/DrivingSchoolCategory'}
              component={AdddrivingSchoolCategory}
            />
            <Route
              exact
              path={
                '/BusinessCategoryMaster/Update/DrivingSchoolCategory/:drivingUUID'
              }
              component={AdddrivingSchoolCategory}
            />
            <Route
              exact
              path={
                '/BusinessCategoryMaster/Update/CarDealersCategory/:cardealerUUID'
              }
              component={AddCardealerCategory}
            />
            <Route
              exact
              path={'/ServiceTypeMaster/CarService'}
              component={CarService}
            />
            <Route
              exact
              path={'/ServiceTypeMaster/Add/CarService'}
              component={AddCarService}
            />
            <Route
              exact
              path={'/ServiceTypeMaster/CarService/Update/:carService'}
              component={AddCarService}
            />
            <Route
              exact
              path={'/ServiceTypeMaster/Add/QuickService'}
              component={AddQuickService}
            />
            <Route
              exact
              path={'/ServiceTypeMaster/QuickService/Update/:quickService'}
              component={AddQuickService}
            />
            <Route
              exact
              path={'/ServiceTypeMaster/quickService'}
              component={quickService}
            />
            {/* <Route
							exact
							path={'/ServiceTypeMaster/add/quickService'}
							component={quickService}
						/> */}
            <Route
              exact
              path={'/ServiceTypeMaster/AddCarService'}
              component={AddServiceTypeMaster}
            />
            {/* <Route exact path={'/CarBrandMaster'} component={CarBrandMaster} />  Deleted*/}
            <Route exact path={'/Packages'} component={Package} />
            <Route
              exact
              path={'/CarBrandMaster/AddCarBrandMaster'}
              component={AddCarBrandMaster}
            />
            <Route exact path={'/VehicleType'} component={VehicleType} />
            <Route
              exact
              path={'/VehicleType/ddVehicleType'}
              component={AddVehicleType}
            />
            <Route
              exact
              path={'/SparePartMaster/:type?'}
              component={SparePartMaster}
            />
            <Route
              exact
              path={'/SparePartMaster/:type?/add/CarName'}
              component={AddCarName}
            />
            <Route
              exact
              path={'/SparePartMaster/:type?/add/SpareParts'}
              component={AddSparePart}
            />
            <Route
              exact
              path={'/SparePartMaster/SpareParts/Update/:spUUID'}
              component={AddSparePart}
            />
            <Route
              exact
              path={'/SparePartMaster/:type?/add/SparePartTypes'}
              component={AddSparePartType}
            />
            <Route
              exact
              path={'/ServiceProviders/Agent/ManageCars'}
              component={ManageCars}
            />
            <Route
              exact
              path={'/ServiceProviders/Agent/ManageShowRoom'}
              component={ManageShowRoom}
            />
            <Route
              exact
              path={'/ServiceProviders/Agent/ManageWorkShop'}
              component={ManageWorkShop}
            />
            <Route
              exact
              path={'/ServiceProviders/Agent/ManageCatagory'}
              component={ManageCatagory}
            />
            <Route
              exact
              path={'/ServiceProviders/Agent/AddNewCategory'}
              component={AddNewCategory}
            />
            <Route
              exact
              path={'/ServiceProviders/Agent/AddManageCAr'}
              component={AddNewManageCars}
            />
            <Route
              exact
              path={'/ServiceProviders/Agent/AddNewManageShowRoom'}
              component={AddNewManageShowRoom}
            />
            <Route
              exact
              path={'/ServiceProviders/Agent/AddNewManageWorkShop'}
              component={AddNewManageWorkShop}
            />
            <Route
              exact
              path={'/delete-business-data'}
              component={DeleteBusinessData}
            />
            <Route exact path={'/ProductMaster'} component={ProductListTable} />
            <Route
              exact
              path={'/ProductMaster/AddProductMaster'}
              component={AddProduct}
            />
            <Route exact path={'/notification'} component={Notification} />
            <Route exact path={'/contact-us'} component={ContactUS} />
            <Route
              exact
              path={'/CarDetail/CarBrand/CarModel/:brandId'}
              component={CarMB}
            />
          </Home>
        )}
      </Router>
    );
  }
}

export default Routes;
